import React, { useState, useEffect } from 'react'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useMutation, useQuery } from 'react-query'
import { Formik, Form, Field, FieldArray,ErrorMessage } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import { useQueryClient } from 'react-query'
import * as AiIcons from 'react-icons/ai';
import { useHistory, useParams } from 'react-router'
import Select from 'react-select'

function ImsClausesMaster() {
    const { id } = useParams()
    const history = useHistory();
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(
        {
            _id: "",
            nameOfProcess: "",

            clauseDetails: [{
                clauseNo: "",
                clauseDescription: "",
            }],

        })
    const validationSchema = Yup.object({
        nameOfProcess       :Yup.string().required("Required"),
        clauseDetails       : Yup.array().of( Yup.object().shape({
                                    clauseNo        : Yup.string().required("Required"),
                                    clauseDescription: Yup.string().required("Required")
                                })
                            )
    })

    const onSubmit = (values, { setSubmitting, resetForm }) => {
        if (values._id === "") {
            mutation.mutate(values)
        } else {
            console.log("value edit", values)
            mutationEdit.mutate(values)

        }
    }
    const mutation = useMutation((params) => Fetcher('post', '/api/imsClausesMaster/post/data', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Ims Clause Added')
                queryClient.invalidateQueries('listClaouseData');
                window.location.href = '/admin/listofclauses'

            } else {

                var msg = 'Ims Clauses- ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationEdit = useMutation((params) => Fetcher('patch', '/api/imsClausesMaster/patch/clauses', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {

                ToastInstance('Success', 'Data Updated')
                queryClient.invalidateQueries('listClaouseData');
                window.location.href = '/admin/listofclauses'


            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })

    const { data: clauseData, isLoading } = useQuery(
        'listClaouseData',
        () => Fetcher('get', '/api/imsClausesMaster/get/clausesbyid/' + id, {}))

    useEffect(() => {
        if (clauseData && initialValues._id === "") {
            var tempData = clauseData.data.response
            setInitialValues(tempData)

        }
    }, [id && !isLoading && initialValues._id === ""])


    // if (nacecodeListLoading) return <h1>Loading</h1>

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >

            {
                formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row htmlpage">
                                                <div className="col-sm-12">
                                                    <div className="row">
                                                        <div className="form1RowDiv">

                                                            <FormikControl className="form-control" control='textarea' label="Name Of Process *" name='nameOfProcess' />
                                                        </div>
                                                        <div className="col-sm-1" />

                                                    </div>

                                                    <div className="container-fluid mt-5" style={{ border: "1px solid black" }}>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4 ">Clause # <span className="required-field">*</span></label>
                                                            <label htmlFor="staticEmail" className="col-sm-4 ">Clause Description<span className="required-field">*</span></label>

                                                        </div>
                                                        <div className="row">
                                                            <FieldArray name='clauseDetails'>
                                                                {fieldArrayProps => {
                                                                    const { push, remove, form } = fieldArrayProps
                                                                    const { values } = form
                                                                    const { clauseDetails } = values
                                                                    return (
                                                                        <div>
                                                                            {clauseDetails.map((clauseDetail, index) => (
                                                                                <div key={index}>
                                                                                    <div className="row mt-3">


                                                                                        <div className="col-sm-4 ">
                                                                                            <Field className="form-control" name={`clauseDetails[${index}].clauseNo`} />
                                                                                            <div style={{color : "red"}}>
                                                                                                <ErrorMessage  name={`clauseDetails[${index}].clauseNo`}/>
                                                                                            </div>
                                                                                            </div>
                                                                                           
                                                                                        <div className="col-sm-7 ">
                                                                                            <Field className="form-control" name={`clauseDetails[${index}].clauseDescription`} />
                                                                                            <div style={{color : "red"}}>
                                                                                                <ErrorMessage  name={`clauseDetails[${index}].clauseDescription`}/>
                                                                                            </div>
                                                                                        </div>
                                                                                        {index > 0 && (
                                                                                            <div className="col-sm-1">
                                                                                                <span style={{ "marginLeft": "6%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px" }} /></span>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ))}

                                                                            <div className="row mt-3">
                                                                                <div className="col-lg-11"></div>
                                                                                <div className="col-lg-1 mb-3" >
                                                                                    <button type='button' className="btn btn-primary" onClick={() => push('')}>Add</button>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    )
                                                                }}
                                                            </FieldArray>
                                                        </div>

                                                    </div>
                                                    <br />
                                                    <div className="row mt-3">
                                                        <div className="col-lg-11"></div>
                                                        <div className="col-lg-1" >
                                                            <button type="submit" className="btn btn-primary" >Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </section>

                    </div>


                </Form>

            }
        </Formik>
    )
}

export default ImsClausesMaster
